import React from "react";
import { Tooltip } from "../../../revvComponents";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import IconDocumentDecline from "../../../assets/svg/IconDocumentDecline";

const RecipientDeclineBtn = props => {
  const _declineBtn = () => (
    <span
      className={`recipientdocheader-download-button ${props.className}`}
      data-test="recipientdocheader-decline-button"
      onClick={props.handleDocumentDecline}
      tabIndex="0"
      onKeyDown={() => {}}
      role="button">
      <IconDocumentDecline classNames="recipientdocheaderbuttons-icon" />
      {/* <FontAwesomeIcon
        icon={["far", "thumbs-down"]}
        className="recipientdocheaderbuttons-icon accept-decline-btn"
      /> */}
      {props.usedFor === "DROPDOWN" && "Decline"}
    </span>
  );
  return props.isMobileView ? (
    _declineBtn()
  ) : (
    <Tooltip
      placement={props.tooltipPlacement}
      align={{
        offset: [0, 4],
      }}
      overlay="Decline this doc">
      {_declineBtn()}
    </Tooltip>
  );
};

export default RecipientDeclineBtn;
